import { forceLogout } from "commonFunctions/forceLogout";
import React from "react";

const TabRestrictWarning = (props) => {
    return <div style={{
        color: "var(--hti-magenta)",
        display: "flex", 
        justifyContent: "center", 
        flexDirection: "column",
        width: "100%",
        marginTop: "24px"
        }}>
        <div style={{fontSize: "1.5rem"}}>This application is already open in another tab or window.</div> 
        <div style={{fontSize: "1.5rem"}}>Please close this tab and return to the active one.</div>
        <div style={{fontSize: "1.5rem"}}>If you've already closed the other tabs and still see this message, 
            <span onClick={() => forceLogout()}  style={{fontSize: "1.4rem", color: "blue", cursor: "pointer"}}> Click here </span>
            to logout and login again.</div>
    </div>
}

export default TabRestrictWarning;